export const graphColor = {
  方剂: "#1b9e77", // 深绿色
  中药材: "#2a9d8f", // 浅绿色
  病症: "#e76f51", // 红色
  中药材功效: "#264653", // 深蓝色
  方剂主治: "#264653", // 深蓝色
};

export const graphBorderColor = {
  方剂: "#1d7a6e", // 深绿色
  中药材: "#1d7a6e", // 浅绿色
  病症: "#d1653e", // 浅红色
  中药材功效: "#1d3557", // 深蓝色
  方剂主治: "#1d3557", // 深蓝色
};
